export const environment = {
	production: false,
	stage: false,
	apiUrl: 'https://otto-api-dev.primeholding.com/api',
	// apiUrl: 'http://localhost:5500/api',
	// apiUrl: 'http://100.81.10.110:32696/api',
	websiteUrl: 'https://dev.weareotto.com/',
};
